import { atom } from 'jotai'

/**
 * Jotai atom storing the snapshot of the user's original permissions,
 * captured the first time the permission panel is used.
 *
 * `null` means the snapshot has not been taken yet.
 * State is in-memory only and resets on page refresh.
 */
export const permissionsSnapshotAtom = atom<string[] | null>(null)
